export function ProfileSelectorLoading() {
  return (
    <div className="px-3 py-4">
      <div className="d-flex flex-column gap-2">
        {[1, 2, 3].map((i) => (
          <div key={i} className="d-flex align-items-center gap-2">
            <div className="placeholder-glow">
              <span className="avatar avatar-sm placeholder" />
            </div>
            <div className="flex-grow-1 placeholder-glow">
              <span className="placeholder col-8" />
              <span className="placeholder col-5 placeholder-sm" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
